// 必要なコンポーネントや型、ライブラリをインポート
import UserFrame from "../organisms/UserFrame"; // ユーザー用のフレームコンポーネント
import { Container } from '@mui/material'; // Material-UIのコンテナコンポーネント
import UCList, { UCListType } from '../organisms/UCList'; // ユーザーコレクションリストおよびその型

// コンポーネントに渡されるpropsの型定義
type Props = {
    data: UCListType[] // UCListType型のデータ配列を受け取る
}

/** 
 * ユーザーの資料一覧を表示するテンプレートコンポーネント
 * @param props - UCListに渡す資料データ
 */
const UserCollectionTemplate = (props: Props) => {
    return (
        // ユーザー専用フレームでコンテンツをラップ
        <UserFrame title=''> {/* titleプロパティは空の状態 */}
            {/* コンテンツを中央寄せで最大幅lg（ラージサイズ）で表示 */}
            <Container maxWidth='lg'>
                {/* UCListコンポーネントを利用して資料データを表示 */}
                <UCList data={props.data}/>
            </Container>
        </UserFrame>
    )
}

// コンポーネントをエクスポート
export default UserCollectionTemplate;
